<template>
  <v-row>
    <v-col
      class="d-flex child-flex"
      cols="4">

      <v-img v-for="photo in photos" v-bind:key="photo" :src="photo" aspect-ratio="1" class="grey lighten-2">
        <template v-slot:placeholder>
          <v-row
            class="fill-height ma-0"
            align="center"
            justify="center"
          >
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Gallery",
  props: {
    photos: Array
  }
};
</script>

<style scoped>

</style>